import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { Grid } from "@mui/material";
import MetricPartition from "../../metrics/metric-partition";
import { useApiTenant } from "../../../../api/api-tenant";
import useOnScreen from "../../../../helpers/on-screen";
import { metricColors } from "../../../../helpers/colors";
export default function TicketsMetricsTimeContactCall({ type, group_id, campaign, globalRange, setGlobalRange, globalStartDate, globalStartTime, globalEndDate, globalEndTime, isChosenGlobalCustomRange, }) {
    const { t } = useTranslation();
    const api = useApiTenant();
    const ref = useRef(null);
    const onScreen = useOnScreen(ref, "-100px");
    const [wasOnScreen, setWasOnScreen] = useState(false);
    const [ticketsClosingTimeData, setTicketsClosingTimeData] = useState([]);
    const [ticketsClosingTimeError, setTicketsClosingTimeError] = useState(false);
    const [ticketsClosingTimeCachedAt, setTicketsClosingTimeCachedAt] = useState("");
    const [ticketsClosingTimeRange, setTicketsClosingTimeRange] = useState("total");
    const [ticketsClosingTimeLoading, setTicketsClosingTimeLoading] = useState(true);
    const [ticketsClosingTimeMetricsRefresh, setTicketsClosingTimeMetricsRefresh] = useState(false);
    const [ticketsClosingTimeStartDate, setTicketsClosingTimeStartDate] = useState("");
    const [ticketsClosingTimeEndDate, setTicketsClosingTimeEndDate] = useState("");
    const [ticketsClosingTimeStartTime, setTicketsClosingTimeStartTime] = useState("");
    const [ticketsClosingTimeEndTime, setTicketsClosingTimeEndTime] = useState("");
    const [isChosenClosingTimeCustomRange, setIsChosenClosingTimeCustomRange] = useState(false);
    const [ticketsClosingTimeChosenStatuses, setTicketsClosingTimeChosenStatuses] = useState([]);
    const [ticketsClosingTimeChosenPriorities, setTicketsClosingTimeChosenPriorities] = useState([]);
    const [ticketsNewContactsData, setTicketsNewContactsData] = useState([]);
    const [ticketsNewContactsError, setTicketsNewContactsError] = useState(false);
    const [ticketsNewContactsCachedAt, setTicketsNewContactsCachedAt] = useState("");
    const [ticketsNewContactsRange, setTicketsNewContactsRange] = useState("total");
    const [ticketsNewContactsLoading, setTicketsNewContactsLoading] = useState(true);
    const [ticketsNewContactsMetricsRefresh, setTicketsNewContactsMetricsRefresh] = useState(false);
    const [ticketsNewContactsStartDate, setTicketsNewContactsStartDate] = useState("");
    const [ticketsNewContactsEndDate, setTicketsNewContactsEndDate] = useState("");
    const [ticketsNewContactsStartTime, setTicketsNewContactsStartTime] = useState("");
    const [ticketsNewContactsEndTime, setTicketsNewContactsEndTime] = useState("");
    const [isChosenNewContactsCustomRange, setIsChosenNewContactsCustomRange] = useState(false);
    const [ticketsNewContactsChosenStatuses, setTicketsNewContactsChosenStatuses] = useState([]);
    const [ticketsNewContactsChosenPriorities, setTicketsNewContactsChosenPriorities] = useState([]);
    const [ticketsForwardedCallsData, setTicketsForwardedCallsData] = useState([]);
    const [ticketsForwardedCallsError, setTicketsForwardedCallsError] = useState(false);
    const [ticketsForwardedCallsCachedAt, setTicketsForwardedCallsCachedAt] = useState("");
    const [ticketsForwardedCallsRange, setTicketsForwardedCallsRange] = useState("total");
    const [ticketsForwardedCallsLoading, setTicketsForwardedCallsLoading] = useState(true);
    const [ticketsForwardedCallsMetricsRefresh, setTicketsForwardedCallsMetricsRefresh] = useState(false);
    const [ticketsForwardedCallsStartDate, setTicketsForwardedCallsStartDate] = useState("");
    const [ticketsForwardedCallsEndDate, setTicketsForwardedCallsEndDate] = useState("");
    const [ticketsForwardedCallsStartTime, setTicketsForwardedCallsStartTime] = useState("");
    const [ticketsForwardedCallsEndTime, setTicketsForwardedCallsEndTime] = useState("");
    const [isChosenForwardedCallsCustomRange, setIsChosenForwardedCallsCustomRange] = useState(false);
    const [ticketsForwardedCallsChosenStatuses, setTicketsForwardedCallsChosenStatuses] = useState([]);
    const [ticketsForwardedCallsChosenPriorities, setTicketsForwardedCallsChosenPriorities] = useState([]);
    const getTicketsForwardedCallsValues = invalidateCache => {
        setTicketsForwardedCallsLoading(true);
        if (ticketsForwardedCallsError)
            setTicketsForwardedCallsError(false);
        let startTime;
        let endTime;
        if (ticketsForwardedCallsRange === "custom" &&
            ticketsForwardedCallsStartDate !== "" &&
            ticketsForwardedCallsEndDate !== "") {
            if (ticketsForwardedCallsStartTime !== "") {
                startTime =
                    format(new Date(ticketsForwardedCallsStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsForwardedCallsStartTime), "HH:mm:ss");
            }
            else {
                startTime =
                    format(new Date(ticketsForwardedCallsStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (ticketsForwardedCallsEndTime !== "") {
                endTime =
                    format(new Date(ticketsForwardedCallsEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsForwardedCallsEndTime), "HH:mm") +
                        ":59";
            }
            else {
                endTime = format(new Date(ticketsForwardedCallsEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "tickets", ticketsForwardedCallsRange, "ticketDetail.forwarded_call", undefined, type === "campaign"
            ? "campaign,is_draft"
            : type === "campaign_group"
                ? "campaign,is_draft,groups"
                : "is_draft", type === "campaign"
            ? campaign.id + ",0"
            : type === "campaign_group"
                ? campaign.id + ",0," + group_id
                : "0", type === "campaign_group" ? 1 : undefined, invalidateCache ? 1 : undefined, ticketsForwardedCallsRange === "custom" ? startTime : undefined, ticketsForwardedCallsRange === "custom" ? endTime : undefined, undefined, undefined, campaign && ticketsForwardedCallsChosenStatuses.length > 0
            ? ticketsForwardedCallsChosenStatuses.map(i => i.id)
            : undefined, campaign && ticketsForwardedCallsChosenPriorities.length > 0
            ? ticketsForwardedCallsChosenPriorities.map(i => i.id)
            : undefined)
            .then(response => {
            let metricsData = [];
            response.data.data
                .sort((a, b) => a.count - b.count)
                .reverse()
                .map((a, i) => {
                metricsData.push({
                    label: a.label,
                    count: a.count,
                    color: metricColors[i],
                });
            });
            setTicketsForwardedCallsData(metricsData);
            setTicketsForwardedCallsCachedAt(response.data.cached_at);
            setTicketsForwardedCallsLoading(false);
        })
            .catch(error => {
            setTicketsForwardedCallsError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsForwardedCallsLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getTicketsClosingTimeValues = invalidateCache => {
        setTicketsClosingTimeLoading(true);
        if (ticketsClosingTimeError)
            setTicketsClosingTimeError(false);
        let startTime;
        let endTime;
        if (ticketsClosingTimeRange === "custom" &&
            ticketsClosingTimeStartDate !== "" &&
            ticketsClosingTimeEndDate !== "") {
            if (ticketsClosingTimeStartTime !== "") {
                startTime =
                    format(new Date(ticketsClosingTimeStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsClosingTimeStartTime), "HH:mm:ss");
            }
            else {
                startTime =
                    format(new Date(ticketsClosingTimeStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (ticketsClosingTimeEndTime !== "") {
                endTime =
                    format(new Date(ticketsClosingTimeEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsClosingTimeEndTime), "HH:mm") +
                        ":59";
            }
            else {
                endTime = format(new Date(ticketsClosingTimeEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "tickets", ticketsClosingTimeRange, "id", undefined, type === "campaign"
            ? "campaign,is_draft,ticketDetail.status.type"
            : type === "campaign_group"
                ? "campaign,is_draft,groups,ticketDetail.status.type"
                : "is_draft,ticketDetail.status.type", type === "campaign"
            ? campaign.id + ",0,2"
            : type === "campaign_group"
                ? campaign.id + ",0," + group_id + ",2"
                : "0,2", type === "campaign_group" ? 1 : undefined, invalidateCache ? 1 : undefined, ticketsClosingTimeRange === "custom" ? startTime : undefined, ticketsClosingTimeRange === "custom" ? endTime : undefined, undefined, undefined, campaign && ticketsClosingTimeChosenStatuses.length > 0
            ? ticketsClosingTimeChosenStatuses.map(i => i.id)
            : undefined, campaign && ticketsClosingTimeChosenPriorities.length > 0
            ? ticketsClosingTimeChosenPriorities.map(i => i.id)
            : undefined, "ticketDetail->ticketClosingTime")
            .then(response => {
            let metricsData = [];
            response.data.data
                .sort((a, b) => a.label.localeCompare(b.label))
                .sort(function (a, b) {
                return a.count - b.count;
            })
                .reverse()
                .map((a, i) => {
                let label = "";
                if (a.label === "more-than-2-days") {
                    label = t("tickets.metrics.closing-time-intervals.more-than-2-days");
                }
                else if (a.label === "less-than-2-days") {
                    label = t("tickets.metrics.closing-time-intervals.less-than-2-days");
                }
                else if (a.label === "less-than-1-day") {
                    label = t("tickets.metrics.closing-time-intervals.less-than-1-day");
                }
                else if (a.label === "less-than-8-hours") {
                    label = t("tickets.metrics.closing-time-intervals.less-than-8-hours");
                }
                else if (a.label === "less-than-4-hours") {
                    label = t("tickets.metrics.closing-time-intervals.less-than-4-hours");
                }
                else if (a.label === "less-than-2-hours") {
                    label = t("tickets.metrics.closing-time-intervals.less-than-2-hours");
                }
                else if (a.label === "less-than-30-minutes") {
                    label = t("tickets.metrics.closing-time-intervals.less-than-30-minutes");
                }
                metricsData.push({ label: label, count: a.count, color: metricColors[i] });
            });
            setTicketsClosingTimeData(metricsData);
            setTicketsClosingTimeCachedAt(response.data.cached_at);
            setTicketsClosingTimeLoading(false);
        })
            .catch(error => {
            setTicketsClosingTimeError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsClosingTimeLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getTicketsNewContactsValues = invalidateCache => {
        setTicketsNewContactsLoading(true);
        if (ticketsNewContactsError)
            setTicketsNewContactsError(false);
        let startTime;
        let endTime;
        if (ticketsNewContactsRange === "custom" &&
            ticketsNewContactsStartDate !== "" &&
            ticketsNewContactsEndDate !== "") {
            if (ticketsNewContactsStartTime !== "") {
                startTime =
                    format(new Date(ticketsNewContactsStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsNewContactsStartTime), "HH:mm:ss");
            }
            else {
                startTime =
                    format(new Date(ticketsNewContactsStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (ticketsNewContactsEndTime !== "") {
                endTime =
                    format(new Date(ticketsNewContactsEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsNewContactsEndTime), "HH:mm") +
                        ":59";
            }
            else {
                endTime = format(new Date(ticketsNewContactsEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "tickets", ticketsNewContactsRange, "contact_is_new", undefined, type === "campaign"
            ? "campaign,is_draft"
            : type === "campaign_group"
                ? "campaign,is_draft,groups"
                : "is_draft", type === "campaign"
            ? campaign.id + ",0"
            : type === "campaign_group"
                ? campaign.id + ",0," + group_id
                : "0", type === "campaign_group" ? 1 : undefined, invalidateCache ? 1 : undefined, ticketsNewContactsRange === "custom" ? startTime : undefined, ticketsNewContactsRange === "custom" ? endTime : undefined, undefined, undefined, campaign && ticketsNewContactsChosenStatuses.length > 0
            ? ticketsNewContactsChosenStatuses.map(i => i.id)
            : undefined, campaign && ticketsNewContactsChosenPriorities.length > 0
            ? ticketsNewContactsChosenPriorities.map(i => i.id)
            : undefined)
            .then(response => {
            let metricsData = [];
            response.data.data
                .sort((a, b) => a.label.localeCompare(b.label))
                .sort(function (a, b) {
                return a.count - b.count;
            })
                .reverse()
                .map((a, i) => {
                metricsData.push({
                    label: a.label,
                    count: a.count,
                    color: metricColors[i],
                });
            });
            setTicketsNewContactsData(metricsData);
            setTicketsNewContactsCachedAt(response.data.cached_at);
            setTicketsNewContactsLoading(false);
        })
            .catch(error => {
            setTicketsNewContactsError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsNewContactsLoading(false);
            }
        });
        return () => api.cancel();
    };
    useEffect(() => {
        if (onScreen && !wasOnScreen)
            setWasOnScreen(true);
    }, [onScreen]);
    useEffect(() => {
        if (!wasOnScreen)
            return;
        if (ticketsNewContactsRange !== "custom") {
            setTicketsNewContactsStartDate("");
            setTicketsNewContactsEndDate("");
            setTicketsNewContactsStartTime("");
            setTicketsNewContactsEndTime("");
        }
        getTicketsNewContactsValues(undefined);
    }, [ticketsNewContactsRange, wasOnScreen]);
    useEffect(() => {
        if (!wasOnScreen)
            return;
        if (ticketsClosingTimeRange !== "custom") {
            setTicketsClosingTimeStartDate("");
            setTicketsClosingTimeEndDate("");
            setTicketsClosingTimeStartTime("");
            setTicketsClosingTimeEndTime("");
        }
        getTicketsClosingTimeValues(undefined);
    }, [ticketsClosingTimeRange, wasOnScreen]);
    useEffect(() => {
        if (!wasOnScreen)
            return;
        if (ticketsForwardedCallsRange !== "custom") {
            setTicketsForwardedCallsStartDate("");
            setTicketsForwardedCallsEndDate("");
            setTicketsForwardedCallsStartTime("");
            setTicketsForwardedCallsEndTime("");
        }
        getTicketsForwardedCallsValues(undefined);
    }, [ticketsForwardedCallsRange, wasOnScreen]);
    useEffect(() => {
        if (globalRange &&
            setGlobalRange &&
            globalRange !== "none" &&
            (ticketsNewContactsRange !== globalRange ||
                (ticketsNewContactsRange === globalRange &&
                    (globalStartDate !== ticketsNewContactsStartDate ||
                        globalStartTime !== ticketsNewContactsStartTime ||
                        globalEndDate !== ticketsNewContactsEndDate ||
                        globalEndTime !== ticketsNewContactsEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenNewContactsCustomRange &&
            ticketsNewContactsStartDate !== "" &&
            ticketsNewContactsEndDate !== "") {
            getTicketsNewContactsValues(undefined);
            setIsChosenNewContactsCustomRange(false);
        }
    }, [isChosenNewContactsCustomRange]);
    useEffect(() => {
        if (globalRange &&
            setGlobalRange &&
            globalRange !== "none" &&
            (ticketsClosingTimeRange !== globalRange ||
                (ticketsClosingTimeRange === globalRange &&
                    (globalStartDate !== ticketsClosingTimeStartDate ||
                        globalStartTime !== ticketsClosingTimeStartTime ||
                        globalEndDate !== ticketsClosingTimeEndDate ||
                        globalEndTime !== ticketsClosingTimeEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenClosingTimeCustomRange &&
            ticketsClosingTimeStartDate !== "" &&
            ticketsClosingTimeEndDate !== "") {
            getTicketsClosingTimeValues(undefined);
            setIsChosenClosingTimeCustomRange(false);
        }
    }, [isChosenClosingTimeCustomRange]);
    useEffect(() => {
        if (globalRange &&
            setGlobalRange &&
            globalRange !== "none" &&
            (ticketsForwardedCallsRange !== globalRange ||
                (ticketsForwardedCallsRange === globalRange &&
                    (globalStartDate !== ticketsForwardedCallsStartDate ||
                        globalStartTime !== ticketsForwardedCallsStartTime ||
                        globalEndDate !== ticketsForwardedCallsEndDate ||
                        globalEndTime !== ticketsForwardedCallsEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenForwardedCallsCustomRange &&
            ticketsForwardedCallsStartDate !== "" &&
            ticketsForwardedCallsEndDate !== "") {
            getTicketsForwardedCallsValues(undefined);
            setIsChosenForwardedCallsCustomRange(false);
        }
    }, [isChosenForwardedCallsCustomRange]);
    useEffect(() => {
        if (ticketsNewContactsChosenStatuses.length !== 0 ||
            ticketsNewContactsChosenPriorities.length !== 0) {
            getTicketsNewContactsValues(false);
        }
    }, [ticketsNewContactsChosenStatuses.length, ticketsNewContactsChosenPriorities.length]);
    useEffect(() => {
        if (ticketsClosingTimeChosenStatuses.length !== 0 ||
            ticketsClosingTimeChosenPriorities.length !== 0) {
            getTicketsClosingTimeValues(false);
        }
    }, [ticketsClosingTimeChosenStatuses.length, ticketsClosingTimeChosenPriorities.length]);
    useEffect(() => {
        if (ticketsForwardedCallsChosenStatuses.length !== 0 ||
            ticketsForwardedCallsChosenPriorities.length !== 0) {
            getTicketsForwardedCallsValues(false);
        }
    }, [ticketsForwardedCallsChosenStatuses.length, ticketsForwardedCallsChosenPriorities.length]);
    useEffect(() => {
        if (ticketsNewContactsMetricsRefresh) {
            getTicketsNewContactsValues(true);
            setTicketsNewContactsMetricsRefresh(false);
        }
        else if (ticketsClosingTimeMetricsRefresh) {
            getTicketsClosingTimeValues(true);
            setTicketsClosingTimeMetricsRefresh(false);
        }
        else if (ticketsForwardedCallsMetricsRefresh) {
            getTicketsForwardedCallsValues(true);
            setTicketsForwardedCallsMetricsRefresh(false);
        }
    }, [
        ticketsNewContactsMetricsRefresh,
        ticketsClosingTimeMetricsRefresh,
        ticketsForwardedCallsMetricsRefresh,
    ]);
    useEffect(() => {
        if (globalRange && globalRange !== "none" && globalRange !== "custom") {
            if (ticketsNewContactsRange !== globalRange ||
                ticketsClosingTimeRange !== globalRange ||
                ticketsForwardedCallsRange !== globalRange) {
                setTicketsNewContactsRange(globalRange);
                setTicketsClosingTimeRange(globalRange);
                setTicketsForwardedCallsRange(globalRange);
                if (wasOnScreen)
                    setWasOnScreen(false);
            }
        }
    }, [globalRange]);
    useEffect(() => {
        if (isChosenGlobalCustomRange &&
            globalRange &&
            globalRange === "custom" &&
            globalStartDate &&
            globalStartDate !== "" &&
            globalEndDate &&
            globalEndDate !== "") {
            if (wasOnScreen)
                setWasOnScreen(false);
            setTicketsNewContactsStartDate(globalStartDate);
            setTicketsNewContactsEndDate(globalEndDate);
            setTicketsClosingTimeStartDate(globalStartDate);
            setTicketsClosingTimeEndDate(globalEndDate);
            setTicketsForwardedCallsStartDate(globalStartDate);
            setTicketsForwardedCallsEndDate(globalEndDate);
            setTicketsNewContactsStartTime(globalStartTime ? globalStartTime : "");
            setTicketsClosingTimeStartTime(globalStartTime ? globalStartTime : "");
            setTicketsForwardedCallsStartTime(globalStartTime ? globalStartTime : "");
            setTicketsNewContactsEndTime(globalEndTime ? globalEndTime : "");
            setTicketsClosingTimeEndTime(globalEndTime ? globalEndTime : "");
            setTicketsForwardedCallsEndTime(globalEndTime ? globalEndTime : "");
            setTicketsNewContactsRange(globalRange);
            setTicketsClosingTimeRange(globalRange);
            setTicketsForwardedCallsRange(globalRange);
        }
    }, [isChosenGlobalCustomRange]);
    const hasForwardedCalls = true;
    // !campaign ||
    // (campaign && campaign.field_options.find(a => a.data === "forwarded_call" && a.visible))
    return (_jsxs(Grid, Object.assign({ ref: ref, container: true, spacing: 4, width: "100%", marginLeft: "0px", paddingTop: "32px" }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: hasForwardedCalls ? 4 : 6 }, { children: _jsx(MetricPartition, { title: t("tickets.metrics.closing-time"), range: ticketsClosingTimeRange, setRange: setTicketsClosingTimeRange, isLoading: ticketsClosingTimeLoading, setIsLoading: setTicketsClosingTimeLoading, cachedAt: ticketsClosingTimeCachedAt, refresh: ticketsClosingTimeMetricsRefresh, setRefresh: setTicketsClosingTimeMetricsRefresh, startDate: ticketsClosingTimeStartDate, setStartDate: setTicketsClosingTimeStartDate, endDate: ticketsClosingTimeEndDate, setEndDate: setTicketsClosingTimeEndDate, startTime: ticketsClosingTimeStartTime, setStartTime: setTicketsClosingTimeStartTime, endTime: ticketsClosingTimeEndTime, setEndTime: setTicketsClosingTimeEndTime, globalRange: globalRange, setGlobalRange: setGlobalRange, setIsChosenCustomRange: setIsChosenClosingTimeCustomRange, metricData: ticketsClosingTimeData, type: type, metricType: "closing_time", isError: ticketsClosingTimeError, statuses: campaign
                        ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses.filter(status => status.type === "resolved")
                        : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsClosingTimeChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsClosingTimeChosenStatuses : undefined, chosenPriorities: campaign ? ticketsClosingTimeChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsClosingTimeChosenPriorities : undefined }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: hasForwardedCalls ? 4 : 6 }, { children: _jsx(MetricPartition, { title: t("tickets.metrics.new-vs-existing-contacts"), range: ticketsNewContactsRange, setRange: setTicketsNewContactsRange, isLoading: ticketsNewContactsLoading, setIsLoading: setTicketsNewContactsLoading, cachedAt: ticketsNewContactsCachedAt, refresh: ticketsNewContactsMetricsRefresh, setRefresh: setTicketsNewContactsMetricsRefresh, startDate: ticketsNewContactsStartDate, setStartDate: setTicketsNewContactsStartDate, endDate: ticketsNewContactsEndDate, setEndDate: setTicketsNewContactsEndDate, startTime: ticketsNewContactsStartTime, setStartTime: setTicketsNewContactsStartTime, endTime: ticketsNewContactsEndTime, setEndTime: setTicketsNewContactsEndTime, globalRange: globalRange, setGlobalRange: setGlobalRange, setIsChosenCustomRange: setIsChosenNewContactsCustomRange, metricData: ticketsNewContactsData, type: type, metricType: "new_contact", isError: ticketsNewContactsError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsNewContactsChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsNewContactsChosenStatuses : undefined, chosenPriorities: campaign ? ticketsNewContactsChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsNewContactsChosenPriorities : undefined }) })), hasForwardedCalls ? (_jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: 4 }, { children: _jsx(MetricPartition, { title: t("tickets.metrics.forwarded-calls"), range: ticketsForwardedCallsRange, setRange: setTicketsForwardedCallsRange, isLoading: ticketsForwardedCallsLoading, setIsLoading: setTicketsForwardedCallsLoading, cachedAt: ticketsForwardedCallsCachedAt, refresh: ticketsForwardedCallsMetricsRefresh, setRefresh: setTicketsForwardedCallsMetricsRefresh, startDate: ticketsForwardedCallsStartDate, setStartDate: setTicketsForwardedCallsStartDate, endDate: ticketsForwardedCallsEndDate, setEndDate: setTicketsForwardedCallsEndDate, startTime: ticketsForwardedCallsStartTime, setStartTime: setTicketsForwardedCallsStartTime, endTime: ticketsForwardedCallsEndTime, setEndTime: setTicketsForwardedCallsEndTime, globalRange: globalRange, setGlobalRange: setGlobalRange, setIsChosenCustomRange: setIsChosenForwardedCallsCustomRange, metricData: ticketsForwardedCallsData, type: type, metricType: "forwarded_calls", isError: ticketsForwardedCallsError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsForwardedCallsChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsForwardedCallsChosenStatuses : undefined, chosenPriorities: campaign ? ticketsForwardedCallsChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsForwardedCallsChosenPriorities : undefined }) }))) : null] })));
}
